export enum PresenceState {
  Unknown = 'unknown',
  Connecting = 'connecting',
  Unavailable = 'unavailable',
  Available = 'available',
}

export const getPresenceStateFromNotify = (dialogXml: string) => {
  const parser = new DOMParser()
  const xmlDoc = parser.parseFromString(dialogXml, 'text/xml')
  const state = xmlDoc
    .getElementsByTagName('state')[0]
    .childNodes[0].nodeValue?.toLowerCase()

  switch (state) {
    case 'confirmed':
      return PresenceState.Unavailable
    case 'trying':
      return PresenceState.Connecting
    case 'early':
      return PresenceState.Connecting
    case 'terminated':
      return PresenceState.Available
    default:
      return PresenceState.Unknown
  }
}
